import { render, staticRenderFns } from "./ModdingQuickstart.vue?vue&type=template&id=01590304&"
import script from "./ModdingQuickstart.vue?vue&type=script&lang=js&"
export * from "./ModdingQuickstart.vue?vue&type=script&lang=js&"
import style0 from "./ModdingQuickstart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports